<template>
    <b-container fluid class="h-100 p-3 bg-gray-light d-flex flex-column overflow-auto" :style="generateVariantStyle(Variant)">
        <b-row class="mr-1">
            <Pins :FilterTreeStore="filterTreeStore" :Variant="Variant" :PropertiesFilterPinTypes="propertiesFilterPinTypes" />
        </b-row>
        <b-row class="pl-4">
            <b-col class="my-3">
                <b-row>
                    <b-col>
                        <b-row>
                            <h3>{{ $t('ExportDistributorData') }}</h3>
                        </b-row>
                        <b-row>
                            <p>{{ $t('Concerne') }}<span class="font-weight-semibold">{{ $t('Meter') }}</span>{{ $t('Perimeter') }}</p>
                        </b-row>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <b-row no-gutters class="ml-1 my-0">
                            <b-col
                                v-for="meterType in meterTypes"
                                :key="meterType.Type.Id"
                                cols="6"
                                class="px-1"
                            >
                                <b-overlay class="w-100" @click="changeMeterType(meterType.Type.Extras.Name)" no-center :show="isMeterTypeSelected(meterType.Type.Extras.Name)" blur="" variant="transparent" role="button">
                                    <template #overlay>
                                        <b-icon font-scale="1" icon="check-circle-fill" shift-h="-15" shift-v="-10" class="position-absolute end-0" :variant="Variant" />
                                    </template>
                                    <b-card body-class="py-1 d-flex flex-column align-items-center justify-content-center" class="w-100 text-black rounded d-flex flex-column align-items-center justify-content-center"  @click="changeMeterType(meterType.Type.Extras.Name)" 
                                        :class="[
                                        'border',
                                        isMeterTypeSelected(meterType.Type.Extras.Name)
                                        ? 'border-' + Variant
                                        : 'border-gray-light',

                                        isMeterTypeSelected(meterType.Type.Extras.Name)
                                            ? 'bg-' + Variant + '-light'
                                            : 'bg-white'
                                    ]">
                                        <b-img :src="AbsoluteLink('Icons/' + meterType.Logo + '_Energy_Icon.svg')" height="20rem" width="20rem" />
                                        <span class="font-weight-semibold">{{ meterType.Label }}</span>
                                    </b-card>
                                </b-overlay>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-card no-body class="mb-3">
                    <b-card-header class="bg-white border-bottom d-flex align-items-center">
                        <b-col>
                            <h5 class="mb-0">{{ $t('ExportSettings') }}</h5>
                        </b-col>
                        <b-col class="d-flex justify-content-end">
                            <b-icon id="info-params-id" icon="info-circle" scale="1.5"></b-icon>

                            <b-tooltip target="info-params-id" variant="dark" placement="top">
                                {{ $t('YearGap') }} <br> {{ $t('Maximum') }}
                            </b-tooltip>
                        </b-col>
                    </b-card-header>
                    <b-card-footer class="bg-white flex-column flex-sm-row">
                        <b-col>
                            <b-row>
                                <b-col>
                                    <b-card no-body class="w-100 bg-white p-0">
                                        <b-card-header class="bg-white p-0">
                                            <h6 class="font-weight-semibold">{{ $t('Period') }}</h6>
                                        </b-card-header>
                                        <b-card-footer class="bg-white p-0 mx-2">
                                            <b-row class="w-100 mr-4">
                                                <b-col class="w-100">
                                                    <b-form-group :label="$t('StartPeriod')"
                                                        label-for="startPeriod"
                                                        label-cols-sm="20"
                                                        label-class="pt-2 pb-0 pr-0 ml-1">
                                                        <DatePicker class="ml-3"  id="startPeriod" :Required="true" v-model="config.StartDate" :State.sync="eventState" :Variant="Variant" :Locale="$store.getters['SessionStore/GetLanguage']" />
                                                    </b-form-group>
                                                </b-col>
                                                <b-col class="w-100">
                                                    <b-form-group :label="$t('EndPeriod')"
                                                        label-for="endPeriod"
                                                        label-cols-sm="20"
                                                        :max="new Date()"
                                                        label-class="pt-2 pb-0 pr-0 ml-1">
                                                        <DatePicker class="ml-3" id="endPeriod" :Required="true" v-model="config.EndDate" :State.sync="eventState" :Variant="Variant" :Locale="$store.getters['SessionStore/GetLanguage']" />
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-card-footer>
                                    </b-card>
                                </b-col>
                            </b-row>

                            <b-row class="mt-1">
                                <b-card no-body class="w-100 bg-white p-0">
                                    <b-card-header class="bg-white p-0 mx-3">
                                        <h6 class="font-weight-semibold">{{ $t('FlowType') }}</h6>
                                    </b-card-header>
                                    <b-card-footer class="bg-white p-0">
                                        <b-row class="mx-2">
                                            <b-col v-for="flow in flowTypes" :key="flow.Id">
                                                <b-overlay @click="flowType = parseInt(flow.Id)" class="m-1" no-center :show="flowType == parseInt(flow.Id)" blur="" variant="transparent" role="button">
                                                    <template #overlay>
                                                        <b-icon font-scale="1.3" icon="check-circle-fill" shift-h="-15" shift-v="-17" class="position-absolute end-0" :variant="Variant" />
                                                    </template>
                                                    <b-card @click="flowType = parseInt(flow.Id)" :class="['border', { ['border-' + Variant + '-dark bg-' + Variant + '-light']: flowType == parseInt(flow.Id)}, { 'border-gray-light bg-gray-light': flowType != parseInt(flow.Id) }]">
                                                        <b-card-body class="py-0 text-black m-0">
                                                            <b-card-text class="mb-0 font-weight-semibold">
                                                                {{ $t(flow.Label) }}
                                                            </b-card-text>
                                                        </b-card-body>
                                                    </b-card>
                                                </b-overlay>
                                            </b-col>
                                        </b-row>
                                    </b-card-footer>
                                </b-card>
                            </b-row>

                            <b-row class="mt-1">
                                <b-card no-body class="w-100 bg-white p-0">
                                    <b-card-header class="bg-white p-0 mx-3">
                                        <h6 class="font-weight-semibold">{{ $t('Issuer') }}</h6>
                                    </b-card-header>
                                    <b-card-footer class="bg-white p-0">
                                        <b-row class="mx-2">
                                            <b-col v-for="issuer in issuerTypes" :key="issuer.Id">
                                                <b-overlay @click="issuerType = parseInt(issuer.Id)" class="m-1" no-center :show="issuerType == parseInt(issuer.Id)" blur="" variant="transparent" role="button">
                                                    <template #overlay>
                                                        <b-icon font-scale="1.3" icon="check-circle-fill" shift-h="-15" shift-v="-17" class="position-absolute end-0" :variant="Variant" />
                                                    </template>
                                                    <b-card @click="issuerType = parseInt(issuer.Id)" :class="['border', { ['border-' + Variant + '-dark bg-' + Variant + '-light']: issuerType == parseInt(issuer.Id)}, { 'border-gray-light bg-gray-light': issuerType != parseInt(issuer.Id) }]">
                                                        <b-card-body class="py-0 text-black m-0">
                                                            <b-card-text class="mb-0 font-weight-semibold">
                                                                {{ $t(issuer.Label) }}
                                                            </b-card-text>
                                                        </b-card-body>
                                                    </b-card>
                                                </b-overlay>
                                            </b-col>
                                        </b-row>
                                    </b-card-footer>
                                </b-card>
                            </b-row>
                        </b-col>
                    </b-card-footer>
                </b-card>
                <b-card no-body>
                    <b-card-header class="bg-white border-bottom d-flex align-items-center">
                        <b-col>
                            <b-row class="align-items-center">
                                <h5 class="mb-0">{{ $t('DataChoice') }}</h5>
                                <b-badge :class="'text-secondary ml-4 mb-0 bg-secondary-light'" pill>{{ this.config.Options.filter(option => option.IsSelected).length }} {{ $t('SelectedItems') }}</b-badge>
                            </b-row>
                        </b-col>
                        <b-col class="d-flex justify-content-end">
                            <label :for="$id('compare')" class="m-0 mr-2">{{$t('SelectAll')}}</label>
                            <b-form-checkbox :id="$id('compare')" :variant="Variant" class="justify-content-between" :checked="allChecked" @change="selectAll" switch :title="$t('SelectAll')" />
                        </b-col>
                    </b-card-header>
                    <b-card-body class="w-100 bg-white px-5 vh-50 d-flex flex-column">
                        <b-row class="w-100 no-gutters align-items-stretch flex-grow-1">
                            <b-col cols="3" class="d-flex" v-if="option.IsVisible" v-for="option in selectedOptions" :key="option.NameString">
                                <b-overlay @click="option.IsSelected = !option.IsSelected" class="my-1 mx-2 flex-fill w-100" no-center :show="option.IsSelected == true" blur="" variant="transparent" role="button">
                                    <template #overlay>
                                        <b-icon font-scale="1.3" icon="check-square-fill" shift-h="-15" shift-v="-15" class="position-absolute end-0" :variant="Variant" />
                                    </template>
                                    <b-card class="h-100 w-100" @click="option.IsSelected = !option.IsSelected" :class="['border', { ['border-' + Variant + '-dark bg-' + Variant + '-light']: option.IsSelected == true}, { 'border-gray-light bg-gray-light': option.IsSelected == false }]">
                                        <b-card-body class="py-2 text-black m-0">
                                            <b-card-text class="mb-0 font-weight-semibold">
                                                {{ option.NameString }}
                                            </b-card-text>
                                            <b-card-text class="mb-0 small">
                                                {{ option.DescriptionString }}
                                            </b-card-text>
                                            <span v-for="(group, index) in option.Types" :key="group">
                                                <span v-if="group != null" class="text-white rounded mx-1 px-2 small" :class="group == 'Equipment_ElectricMeter' ? 'bg-danger' : 'bg-warning'">{{ $t(option.TypeLabels[index]) }}</span>
                                            </span>
                                        </b-card-body>
                                    </b-card>
                                </b-overlay>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
                <b-row class="d-flex justify-content-center mt-3">
                    <b-button :disabled="show"  @click="exportDatas" pill><b-icon icon="file-excel"/>   {{ $t('Export') }}</b-button>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">
    import { MAIN_FILTER_TREE, API_URL } from '@/App.settings';
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import Pins from "@/components/commons/Pins.vue";
    import Dictionary from "@/types/Dictionary";
    import axios from 'axios';
    import EnumItem from "@/types/fields/EnumItem";
    import {Getter} from "vuex-class";
    import { mixins } from 'vue-class-component';

    /** i18n pour la traduction */
    import locales from './locales/DistributorDatas.json';
    import DatePicker from "@/components/commons/DatePicker.vue";
    import { ThemeUtils, LinkUtils } from '@/components/commons/Utils';

    /** Store downloadeur */
    import Download from '@/types/Download';
    import DownloadStateEnum from '@/enums/DownloadStateEnum';
import PinTypeEnum from '@/enums/PinTypeEnum';

    @Component({
        components: {
            /** Pins de filtrage sur l'arborescence */
            Pins,
		    DatePicker
        },
        i18n:{messages: locales},
    })
	export default class DistributorDatas extends mixins(ThemeUtils, LinkUtils) {
        /** Liste des configurations */
        public config: Parameter = {
            StartDate: new Date(),
            EndDate:  new Date(),
            Options: [],
            FlowType: 0,
            IssuerType: 0,
            MeterTypes: []
        };

        /** Variant de couleurs à appliquer */
        @Prop()
        public Variant!:string;

        private eventState: boolean = null;

        /**  Instance d'aborescence à utiliser */
        private filterTreeStore: string = MAIN_FILTER_TREE;

        /** Attribut pour afficher l'overlay */
        private show: boolean = false;

        /** Attribut pour le type de flux */
        private flowType: number | null = null;

        /** Attribut pour le type d'emetteur */
        private issuerType: number | null = null;

        /** Attribut pour stocker l'enum des types de flux */
        private flowTypes: EnumItem[] = [];

        /** Attribut pour stocker l'enum des types d'emetteur */
        private issuerTypes: EnumItem[] = [];

        /** Attribut pour stocker l'enum des types d'obhet pour les types de compteur */
        private meterTypes: MeterType[] = [];

        /** Attribut pour l'ensemble des options sélectionnées */
        private allChecked: boolean = false;

        /** Liste des Type de flux */
        private flows = [1, 2];

        /** Liste des Type d'emetteur */
        private issuers = [1, 2];

        /** Liste des types de Pin pour les filtres par propriétés */
        private propertiesFilterPinTypes: PinTypeEnum[] = [ PinTypeEnum.None, PinTypeEnum.Tree];

        /** Getter pour obtenir une liste */
        @Getter('GetListEnums')
        protected listEnums!: (listName: string) => EnumItem[];

        private async loadEnums() {
            this.$store.dispatch("ShowLoadingMask", this.$t('Loading'));
            await this.$store.dispatch("LoadListItems", [{ listName: 'FlowType' }, { listName: 'IssuerType' }, { listName: 'ObjectType' }]).then(response => {

                this.flowTypes = this.$store.getters["GetListItems"]('FlowType')
                        .filter(a => this.flows.includes(a.Id))
                ;

                this.flowTypes = this.flowTypes.sort((a, b) => b.Label.localeCompare(a.Label));

                this.issuerTypes = this.$store.getters["GetListItems"]('IssuerType')
                    .filter(a => this.issuers.includes(a.Id))
                ;

                const available = new Set(this.getAvailableMeterTypeNames());

                this.meterTypes = this.$store.getters["GetListItems"]('ObjectType')
                    .filter((a: any) => available.has(a.Extras.Name))
                    .map((item: any) => {
                    const logo = item.Extras.Name === "Equipment_ElectricMeter" ? "Electric" : "Gas"; // ou mapping
                    return new MeterType(
                            item,
                            logo,
                            this.$t(item.Extras.Name.replace("Equipment_", "").replace("Meter", "")).toString()
                        );
                    });

                const allowed = new Set(this.meterTypes.map(mt => mt.Type.Extras.Name));
                this.config.MeterTypes = (this.config.MeterTypes ?? []).filter(t => allowed.has(t));

                // Si rien n'est sélectionné (mask vide ou nettoyé), sélection par défaut = tous
                if (this.config.MeterTypes.length === 0) {
                    this.config.MeterTypes = [...allowed];
                }

                this.issuerType = parseInt(this.issuerTypes.find(item => parseInt(item.Id) === this.config.IssuerType).Id);
                this.flowType = parseInt(this.flowTypes.find(item => parseInt(item.Id) === this.config.FlowType).Id);

                this.filterOptionsByMeterType();
            }).catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                this.$store.dispatch("HideLoadingMask", {});
            }).finally(() => {
                this.$store.dispatch("HideLoadingMask", {});
            });
        }

        private getAvailableMeterTypeNames(): string[] {
            const set = new Set<string>();
            (this.config.Options ?? []).forEach(o => (o.Types ?? []).forEach(t => t && set.add(t)));
            return [...set];
        }

        private filterOptionsByMeterType() {
            const selected = this.config.MeterTypes;

            this.config.Options.forEach(option => {
                const types = option.Types ?? [];

                const visible =
                selected.length > 0 &&
                selected.some(mt => types.includes(mt));

                option.IsVisible = visible;

                if (!visible) option.IsSelected = false;
            });
        }

        /** Méthode pour charger le mask de l'utilisateur */
        private async loadMask() {
            this.$store.dispatch("ShowLoadingMask", this.$t('Loading'));
            let args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

            await axios.post(API_URL + "Reporting/WorkDocument/Distributor/LoadMask", args).then((response) => {
                if (response && response.data) {
                    response.data.StartDate = new Date(response.data.StartDate);
                    response.data.EndDate = new Date(response.data.EndDate);

                    this.config = response.data;

                    console.debug('DistributorDatas - LoadMask', this.config);
                }
            })
            .catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                this.$store.dispatch("HideLoadingMask");
            })
            ;
        }

        /** Méthode pour sauvegarder le mask de l'utilisateur */
        private async saveMask() {
            let args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["Parameters"] = this.config;

            await axios.post(API_URL + "Reporting/WorkDocument/Distributor/SaveMask", args).then((response) => {
                if (response && response.data) {
                    console.debug('DistributorDatas - SaveMask');
                }
            })
            .catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            });
        }

        /** Méthode d'exportation des données avec différenciation pour que se soit un fichier zip ou un fichier Excel */
        private async exportDatas() {
            const startYearPlus2 = new Date(this.config.StartDate);
            startYearPlus2.setFullYear(startYearPlus2.getFullYear() + 2);

            const isMoreThanTwoYears = this.config.EndDate > startYearPlus2;

            if(new Date(this.config.EndDate) < new Date(this.config.StartDate)) {
                this.$bvToast.toast(this.$t('StartDateBeforeEndDate').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                return;
            }

            if(isMoreThanTwoYears) {
                this.$bvToast.toast(this.$t('DateError').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                return;
            }

            if(this.config.Options.filter(o => o.IsSelected).length === 0) {
                this.$bvToast.toast(this.$t('NoOptionSelected').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                return;
            }

            if(this.$store.getters[this.filterTreeStore + '/GetPins'].length === 0) {
                this.$bvToast.toast(this.$t('NoPinSelected').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                return;
            }

            this.saveMask();
            this.show = true;

            //this.$store.dispatch("ShowLoadingMask", this.$t('ExportProgress'));

            this.config.FlowType = this.flowType;
            this.config.IssuerType = this.issuerType;

            let args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["Mask"] = this.config;
            args["Pins"] = this.$store.getters[this.filterTreeStore + '/GetPins'];

            let index: number = this.$store.getters['DownloadingStore/GetLastIndex'];
            let download: Download = {Index: ++index, Name: "ExportDistributorDatas", Type: '', State: DownloadStateEnum.InProgress, Data: "", Direct: true};
            this.$store.dispatch('DownloadingStore/AddDownloading', download);

            await axios.post(API_URL + "Reporting/WorkDocument/Distributor/Export", args).then((response) => {
                    if (response && response.data) {

                        const { FileName, ContentType, Content } = response.data;

                        if(response.status == 204)
                        {
                            this.$bvToast.toast(this.$t('NoExportData').toString(), {
                                title: this.$t('Infos').toString(),
                                autoHideDelay: 10000,
                                variant: "info",
                                solid: true,
                                appendToast: true,
                                toaster: "b-toaster-top-center"
                            });
                            this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.None});
                            return;
                        }

                        let typeFile = '.xlsx';

                        if(ContentType.MediaType === 'application/zip'){
                            typeFile = '.zip';
                        }

                        const binary = atob(Content);
                        const len = binary.length;
                        const bytes = new Uint8Array(len);
                        for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
                        const blob = new Blob([bytes], { type: ContentType });

                        this.$store.dispatch('DownloadingStore/UpdateName', {index, value: FileName});
                        this.$store.dispatch('DownloadingStore/UpdateType', {index, value: typeFile});
                        this.$store.dispatch('DownloadingStore/AddData', { index, data: blob });
                        this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.Finished});
                        return;
                    }
                    let message = this.$t('AnErrorOccured').toString();
                    let variantMessage = "danger";

                    if(response.status == 204)
                    {
                        message = this.$t('NoExportData').toString();
                        variantMessage = "info";
                    }

                    this.$bvToast.toast(message, {
                        title: this.$t('Infos').toString(),
                        autoHideDelay: 10000,
                        variant: variantMessage,
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                    this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.None});
                    return;
                })
                .catch(err => {
                    let message = this.$t('AnErrorOccured').toString();
                    let variantMessage = "danger";

                    if(err)
                    {
                        message = this.$t(err.response.statusText).toString();
                        variantMessage = "info";
                    }

                    this.$bvToast.toast(message, {
                        title: this.$t('Error').toString(),
                        autoHideDelay: 10000,
                        variant: variantMessage,
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });

                    this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.Error});
                }).finally(() => {
                    //this.$store.dispatch("HideLoadingMask", {});
                    this.show = false;
            });
        }

        private changeMeterType(meterType: string) {
            const index = this.config.MeterTypes.indexOf(meterType);

            if (index !== -1) {
                // On empêche de retirer le dernier élément
                if (this.config.MeterTypes.length === 1) {
                    return;
                }

                this.config.MeterTypes.splice(index, 1);
            } else {
                this.config.MeterTypes.push(meterType);
            }
        }

        /** Méthode pour filtrer les résultats par rapport a la sélection des choix du header */
        get selectedOptions(): Array<Option> {
            const selectedNames = this.meterTypes
                .filter(mt => this.config.MeterTypes.includes(mt.Type.Extras.Name))
                .map(mt => mt.Type.Extras.Name)

            return this.config.Options.filter(option =>
                option.Types?.some(t => selectedNames.includes(t))
            )
        }

        private isMeterTypeSelected(type: string): boolean {
            return this.config.MeterTypes.includes(type);
        }

        @Watch('config.MeterTypes', { deep: true })
        onMeterTypesSelectedChanged() {
            this.filterOptionsByMeterType();
        }

        private selectAll(value: boolean) {
            console.debug('selectAll', value);
            const visibles = this.config.Options.filter(o => o.IsVisible);

            if(visibles.length === 0){
                this.allChecked = false;
                return;
            }

            visibles.forEach(option => {
                if (option.IsVisible) {
                    option.IsSelected = value;
                }
            });
        }

        async created() {
            await this.loadMask();
            await this.loadEnums();
        }
        
    }

    /** Interface qui représente les données du mask Utilisateur */
    interface Parameter {
        StartDate: Date;
        EndDate: Date;
        Options: Option[];
        FlowType: number;
        IssuerType: number;
        MeterTypes: string[];
    }

    /** Class qui représente les options disponibles à mettre dans la liste des checkboxes 
     * Voir a optimiser pour récupérer les options dynamiquement depuis le back-end sans passer par le controleur DistributorData mais baseController si Enum
    */
    class Option {
        IsSelected: boolean;
        NameString: string;
        DescriptionString: string;
        TypeLabels: string[];
        Types: string[];
        IsVisible: boolean = false;
    }

    /** Class qui représente un type de compteur */
    class MeterType {
        Type: EnumItem;
        Logo: string;
        Label: string;

        constructor(type: EnumItem, logo: string, label: string) {
            this.Type = type;
            this.Logo = logo;
            this.Label = label;
        }
    }
</script>

<style scoped>

:deep(.custom-switch .custom-control-input:checked ~ .custom-control-label::before) {
  background-color: var(--Variant) !important;
  border-color: var(--Variant) !important;
}

</style>